<template>
    <div ref="turnstile"></div>
</template>

<script>

export default {
    name: 'CloudflareTurnstile',

    props: {
        cfTurnstileSiteKey: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            widgetId: ''
        }
    },

    async mounted() {
        const turnstilePromise = new Promise((resolve, reject) => {
            if (window.turnstile === null || !window.turnstile) {
                const el = document.createElement('script');
                el.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
                el.async = true;
                el.defer = true;
                document.head.appendChild(el);

                el.addEventListener('load', () => {
                    resolve(window.turnstile);
                })
            } else {
                resolve(window.turnstile);
            }            
        });

        turnstilePromise.then((ts) => {
            this.widgetId = ts.render(this.$refs.turnstile, {
                sitekey: this.cfTurnstileSiteKey,
                theme: 'light',
                callback: this.store,
                'error-callback': () => { console.debug('Turnstile error'); window.turnstile.reset(this.widgetId); },
                'timeout-callback': () => { console.debug('Turnstile timeout'); window.turnstile.reset(this.widgetId);},
                'expired-callback': () => { console.debug('Turnstile expired'); window.turnstile.reset(this.widgetId);},
            });

            // reset widget every 90 seconds
            setInterval(() => {
                window.turnstile.reset(this.widgetId)
            }, 900000);
        });
    },

    methods: {
        store(token) {
            this.$emit('verify', token);
        }
    }
}
</script>